import { useCallback, useMemo, useState } from "react";
import { Button } from "primereact/button";
import { useWindowSize } from "../../hooks/use-window-size";
import { classNames } from "primereact/utils";
import { authService } from "../../services/auth.service";

export interface EditContentHeaderProps {
  header: string;
  showDeleteButton: boolean;
  showSaveButton?: boolean;
  showCancelButton?: boolean;
  saveButtonDisabled: boolean;
  deleteButtonDisabled?: boolean;
  extraBtn1?: React.ReactNode;
  onSaveClick: () => Promise<any> | void;
  onCancelClick: () => Promise<any> | void;
  onDeleteClick?: () => Promise<any> | void;
}

export function EditContentHeader({
  header,
  showDeleteButton,
  showSaveButton = true,
  showCancelButton = true,
  deleteButtonDisabled = false,
  saveButtonDisabled,
  extraBtn1,
  onSaveClick,
  onCancelClick,
  onDeleteClick,
}: EditContentHeaderProps) {
  const { lg } = useWindowSize();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isAdmin = useMemo(() => {
    return authService.isAdmin();
  }, []);

  const onSave = useCallback(() => {
    setIsSubmitting(true);
    Promise.resolve(onSaveClick()).finally(() => setIsSubmitting(false));
  }, [onSaveClick]);

  const onCancel = useCallback(() => {
    setIsSubmitting(true);
    Promise.resolve(onCancelClick()).finally(() => setIsSubmitting(false));
  }, [onCancelClick]);

  const onDelete = useCallback(() => {
    setIsSubmitting(true);
    if (onDeleteClick) {
      Promise.resolve(onDeleteClick()).finally(() => setIsSubmitting(false));
    }
  }, [onDeleteClick]);

  return (
    <div className="flex justify-content-between">
      {lg && <div className="text-xl font-bold">{header}</div>}
      <div
        className={classNames(
          "flex",
          !lg ? "w-full justify-content-between" : ""
        )}
      >
        {extraBtn1}
        {showSaveButton && (
          <Button
            icon="pi pi-save"
            type="button"
            label="Zapisz"
            loading={isSubmitting}
            className="mr-1 w-full "
            severity="success"
            onClick={onSave}
            disabled={saveButtonDisabled}
          />
        )}
        {showDeleteButton && (
          <Button
            icon="pi pi-trash"
            type="button"
            label="Usuń"
            loading={isSubmitting}
            className="mr-1 w-full"
            severity="danger"
            onClick={onDelete}
            disabled={deleteButtonDisabled}
          />
        )}
        {showCancelButton && (
          <Button
            icon="pi pi-times"
            type="button"
            label="Anuluj"
            severity="warning"
            loading={isSubmitting}
            className="w-full mr-1"
            onClick={onCancel}
          />
        )}
      </div>
    </div>
  );
}
